import React, {memo} from 'react';
import {View, TouchableOpacity} from 'react-native';
import {createUseStyle} from '@redlink/assets/styles';
import {Text, IconCrown, IconCrownDisable, Space, IconArrowLeft} from '@redlink/components/atoms';
import {Button} from '@redlink/components/molecules';
import {useLocale} from '@redlink/assets/locale';

export const PurchaseButton = memo(({isProUser, expireDays, onPress}) => {
    const {styles, colors} = useStyle();
    const {dictionary} = useLocale();

    return isProUser ? (
        <View style={styles.proContainer}>
            <IconCrown/>
            <Space size={8}/>
            <Text style={styles.proText}>{dictionary.proPlanSimple}</Text>
            <Text style={styles.proExpireDaysText}>{`${expireDays} ${dictionary.proPlanExpireDaysPostfix}`}</Text>
        </View>
    ) : (
        <TouchableOpacity activeOpacity={.7} {...{onPress}} style={styles.basicContainer}>
            <IconCrownDisable color={colors.black}/>
            <Space size={8}/>
            <Text style={styles.proText}>{dictionary.basic}</Text>
            <View style={styles.upgradeButtonContainer}>
                <Text style={styles.upgradeButtonText}>{dictionary.upgradePlan}</Text>
                <IconArrowLeft size={16} color={colors.black}/>
            </View>
        </TouchableOpacity>
    );
});

const useStyle = createUseStyle(({colors}) => ({
    planDetailContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: colors.gray7,
        borderRadius: 24,
        padding: 12,
    },
    panDetailText: {
        color: colors.black
    },
    proContainer: {
        borderColor: colors.gray7,
        borderWidth: 1,
        borderRadius: 5,
        padding: 8,
        flexDirection: 'row',
        alignItems: 'center'
    },
    proText: {
        flex: 1,
        color: colors.black,
    },
    proExpireDaysText: {
        color: colors.black,
        fontSize: 12
    },
    basicContainer: {
        backgroundColor: colors.yellow1,
        borderRadius: 5,
        padding: 8,
        flexDirection: 'row',
        alignItems: 'center'
    },
    upgradeButtonContainer: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    upgradeButtonText: {
        color: colors.black,
        fontSize: 12
    }
}));
